// @flow

export const AUTHORITY_SEARCH_MAX_SCORE = 0.2;

export default AUTHORITY_SEARCH_MAX_SCORE;
